// extracted by mini-css-extract-plugin
export default {"styles":"Question2_styles__9ByNw"};